import type { IntlShape } from 'react-intl'
import config from 'constants/config'
import { minimumBalances } from 'constants/creditSnackbar'
import { isTooSoonToShowSnackbar } from 'storage/creditsSnackbar'
import { formatDynamicAmount } from 'lib/format/formatCurrencyIntl'
import { contains } from 'lib/string/stringUtils'

export function shouldShowCreditSnackbar(balance: number, currentCurrency: string, pathname: string, userId: string, headless: boolean) {
  return (
    balance >= minimumBalances[currentCurrency] &&
    pathname &&
    !headless &&
    !contains(pathname, '/account/my-escapes/order/') &&
    !contains(pathname, '/booking/confirmation') &&
    !contains(pathname, '/support') &&
    !isTooSoonToShowSnackbar(userId))
}

export function getCreditSnackbar(intl: IntlShape, balance: number, currentCurrency: string, regionCode: string) {
  return {
    heading: intl.formatMessage(
      {
        id: 'a9LMyyOWTNAQCClgRqhu',
        defaultMessage: 'You have {formattedBalance} credit to spend!',
        description: 'Credit snackbar heading showing available credit balance',
      },
      { formattedBalance: formatDynamicAmount(balance, currentCurrency, regionCode) },
    ),
    message: intl.formatMessage(
      {
        id: 'CRLUtuVodO3eNLMA2zom',
        defaultMessage: 'Use it towards your next {holidaySynonym} before it expires. Apply in checkout.',
        description: 'Credit snackbar message encouraging user to use their credit',
      },
      { holidaySynonym: config.brandConfig.holidaySynonym },
    ),
  }
}
